export default {
	acronym: "Sigle",
	acronymHint: "2 à 10 caractères en majuscules, sera utilisé dans l'URL du temple",
	brandingDesc: "Système complet de gestion de temple d'Umbanda",
	brandingTitle: "Gérez votre Temple",
	confirmPassword: "Confirmer le mot de passe",
	error: "Erreur lors de l'enregistrement. Veuillez réessayer.",
	submit: "Enregistrer le Temple",
	subscribingNotice: "Vous démarrez l'abonnement à un forfait. Après avoir créé votre compte et confirmé votre e-mail, vous vérifierez le forfait et finaliserez le paiement.",
	subtitle: "Créez votre compte et enregistrez votre temple",
	success: "Enregistrement terminé ! Vérifiez votre e-mail pour activer votre compte.",
	templeName: "Nom du Temple",
	templeNameHint: "Une majuscule à chaque mot (ou tout en majuscules)",
	title: "Enregistrer le Temple",
};
